// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCEvBb9oVFlaf38IlHG1eOFO6w910XHfss",
  authDomain: "svgoldjewellery-30c83.firebaseapp.com",
  projectId: "svgoldjewellery-30c83",
  storageBucket: "svgoldjewellery-30c83.firebasestorage.app",
  messagingSenderId: "805365157310",
  appId: "1:805365157310:web:7d60bfa9418d8c5efebdef",
};

// Initialize Firebase App
const app = initializeApp(firebaseConfig);

// Export Services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
